import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Alert, Box, Button, Typography } from '@mui/material';
import api from '../../services/api';

const statusLabel = status => ({ CREATED: 'Creato', SAVED: 'Salvato', APPROVED: 'Approvato', VOIDED: 'Annullato',
  COMPLETED: 'Completato', PAYER_ACTION_REQUIRED: 'In attesa del cliente', PENDING: 'In attesa',
  DECLINED: 'Rifiutato', DENIED: 'Rifiutato', PARTIALLY_REFUNDED: 'Rimborso parziale', REFUNDED: 'Rimborsato',
  FAILED: 'Non riuscito', UNKNOWN: 'Da verificare' }[status] || 'Da verificare');

export default function PayPalProviderStatus({ invoiceId, attemptId }) {
  const { mutate, data, error, isPending } = useMutation({
    mutationFn: async () => (await api.get(`/paypal/invoices/${invoiceId}/attempts/${attemptId}/provider-status`)).data.data,
    retry: false,
  });
  return <Box sx={{ my: 1 }}>
    <Button size="small" onClick={() => mutate()} disabled={isPending}>
      {isPending ? 'Verifica in corso…' : 'Verifica stato su PayPal'}
    </Button>
    {error && <Alert severity="error">{error.response?.data?.message || 'Stato PayPal non disponibile. Nessuna operazione di pagamento eseguita.'}</Alert>}
    {data && !isPending && !error && <Alert severity={data.available ? 'info' : 'warning'}>
      <Typography variant="body2" fontWeight="bold">Verifica in sola lettura · {data.environment === 'live' ? 'Live' : 'Sandbox'}</Typography>
      <Typography variant="body2">Controllato: {new Date(data.checked_at).toLocaleString('it-IT', { timeZone: 'Europe/Rome' })}</Typography>
      {!data.available ? <Typography variant="body2">
        Ordine non disponibile nelle API PayPal. Questo esito non dimostra l’assenza di un incasso: confronta la cronologia del conto Business. Il tentativo resta da verificare.
      </Typography> : <>
        <Typography variant="body2">Stato dell’ordine su PayPal: {statusLabel(data.provider_status)} ({data.provider_status})</Typography>
        {data.has_capture ? <>
          <Typography variant="body2">Acquisizione su PayPal: {statusLabel(data.capture.status)} ({data.capture.status})</Typography>
          <Typography variant="body2">Codice transazione su PayPal: {data.capture.id}</Typography>
        </> : <Typography variant="body2">PayPal non riporta un’acquisizione per questo ordine al momento della verifica.</Typography>}
      </>}
      <Typography variant="body2">Questa verifica non acquisisce denaro e non modifica il tentativo o la contabilità.</Typography>
    </Alert>}
  </Box>;
}
